<template>
<div v-loading.fullscreen.lock="loading">
    <subHeader :title="service.title" :subtitle="'¡Aventura, naturaleza y diversión sin salir de Lima!'" :img_header="img_header"></subHeader>
    <div v-if="service.mstatus == '1'" class="container py-5">

        <div class="row">
            <div class="col-lg-8 col-md-8">
                <div class="row">
                    <div class="section-heading mb-2 w-100 pl-4">
                        <h2 v-text="stepsNames[number]"></h2>
                    </div>
                    <div class="d-md-none w-100 px-3 mb-4">

                    </div>
                    <div class="col-sm-2 d-none d-md-block">
                        <div style="height: 400px;" class="d-none d-md-block">
                            <steps :step="number"></steps>
                        </div>
                    </div>
                    <div class="col-sm-9 card-details">

                        <div class="row mb-3">
                            <div class="col-sm-6">
                                <el-checkbox v-model="corporative.actived" @change="init" :disabled="number !=0 ? true : false">Soy usuario corporativo</el-checkbox>
                            </div>
                            <div class="col-sm-6" v-if="corporative.actived">
                                <el-select v-model="corporative.opd" :disabled="number !=0 ? true : false" placeholder="seleccionar su área de trabajo" filterable class="w-100">
                                    <el-option v-for="item in opds" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </div>
                        </div>

                        <wizard0 v-if="number == 0" :products="products" :number.sync="number" :corporative="corporative" @getWizard0="getWizard0"></wizard0>

                        <wizard1 v-if="number == 1" :product="data_wizard0" :coverage="coverage" :loading.sync="loading" :number.sync="number" @getWizard1="getWizard1"></wizard1>

                        <wizard2 v-if="number == 2" :product="data_wizard0" :number.sync="number" :data_wizard1="data_wizard1" @getWizard2="getWizard2"></wizard2>

                        <wizard3 v-if="number == 3" :number.sync="number" @getWizard3="getWizard3"></wizard3>
                    </div>
                </div>

            </div>
            <div class="col-lg-4 col-md-4">
                <div class="alert alert-warning mb-3">
                    <h4 class="alert-heading">Recuerda:</h4>
                    <div v-html="service.details"></div>
                </div>

                <div class="sky-form">
                    <div class="my-5 form-group otherRow row landscape-row brand-view">
                        <div class="col col-4 text-left"><img src="https://static-content.vnforapps.com/v2/img/pci.png" class="icon_logos2"> </div>
                        <div class="col col-8 text-right">
                            <img src="https://static-content.vnforapps.com/v2/img/bottom/visa.png" class="band_logos">
                            <img src="https://static-content.vnforapps.com/v2/img/bottom/mc.png" class="band_logos multibrand icon-mastercard" style="display: inline;">
                            <img src="https://static-content.vnforapps.com/v2/img/bottom/dc.png" class="band_logos multibrand icon-dinersclub" style="display: inline;">
                            <img src="https://static-content.vnforapps.com/v2/img/bottom/amex.png" class="band_logos amex_logo multibrand icon-amex" style="display: inline;">
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <div v-else>
        <h1>Servicio no diponible</h1>
    </div>
</div>
</template>

<script>
//components
import subHeader from "@/components/common/subHeader"
import steps from "@/components/common/Steps"
import wizard0 from "./wizard0"
import wizard1 from "./wizard1"
import wizard2 from "./wizard2"
import wizard3 from "./wizard3"

//services
import services from "@/services/services.service"
import payment from "@/services/payment.service"
import data from "@/data/common";

export default {
    name: 'Camping',
    components: {
        subHeader,
        steps,
        wizard0,
        wizard1,
        wizard2,
        wizard3
    },
    data: () => ({
        loading: false,
        img_header: 'https://cadenaser00.epimg.net/emisora/imagenes/2017/07/16/radio_valladolid/1500207636_921237_1500208292_rrss_normal.jpg',
        service: {},
        products: [],
        coverage: [],
        stepsNames: data.stepsNames,
        camping: {
            st0: null,
            st1: null,
            st2: null,
            st3: null,
            corporative: null
        },
        number: 0,
        data_wizard0: {},
        data_wizard1: {},
        data_wizard2: {},
        data_wizard3: {},
        corporative: {
            actived: false,
            opd: null
        },
        opds: [],
    }),
    methods: {
        async init() {
            this.loading = true
            this.opds = []
            this.corporative.opd = null

            let res1 = await services.getProducts(this.corporative)
            this.service = res1.data.details
            this.products = res1.data.products


            if(this.corporative.actived){
                    this.opds = res1.data.opds
                    this.$alert(res1.data.message, 'IMPORTANTE')
                    //alert(response.data.message)
                }

            let res2 = await services.getCoverage({
                a: 6,
                b: 'M02'
            })
            this.coverage = res2.data
            this.loading = false
        },
        async sendData() {
            this.loading = true
            await payment.camping(this.camping).then((response) => {
                this.loading = false
                if (response.data.status)
                    window.location.href = response.data.url
                else
                    alert(response.data.message);
            }).catch((error) => {
                alert('Lo sentimos, nuestra plataforma esta presentando inconvenientes, intentalo más tarde')
                this.loading = false

            }).finally(() => {
                this.loading = false
            })
        },
        getWizard0(data) {
            this.data_wizard0 = data
        },
        getWizard1(data) {
            if (data.seat != null) {
                this.data_wizard1 = data
            }
        },
        getWizard2(data) {
            this.data_wizard2 = data
        },
        getWizard3(data) {
            this.data_wizard3 = data
            this.camping.st0 = this.data_wizard0
            this.camping.st1 = this.data_wizard1
            this.camping.st2 = this.data_wizard2
            this.camping.st3 = this.data_wizard3
            this.camping.corporative = this.corporative
            //this.$set(this.camping, this.data_wizard1)
            //this.$set(this.camping, this.data_wizard2)
            //this.$set(this.camping, this.data_wizard3)
            //this.camping.push(this.data_wizard1)
            //this.camping.push(this.data_wizard2)
            //this.camping.push(this.data_wizard3)

            this.sendData()
        }
    },
    created() {
        this.init()
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/camping/Index.vue